import { ArrowLeft } from 'lucide-react'

import { DialogClose, DialogRoot, DialogTitle, SheetContent } from '@/components/ui/dialog'
import { SearchBox } from '@/components/search/search-box'
import { useSearchNavigation } from '@/components/search/use-search-navigation'
import { preferences } from '@/lib/store'

export function SearchSheet({ open, onOpenChange }: { open: boolean; onOpenChange: (open: boolean) => void }) {
  const search = useSearchNavigation()

  return (
    <DialogRoot open={open} onOpenChange={onOpenChange}>
      <SheetContent aria-describedby={undefined} className="pt-safe">
        <div className="flex items-center gap-2 p-3">
          <DialogClose className="rounded-lg p-2 text-muted-foreground hover:bg-accent hover:text-foreground">
            <ArrowLeft className="size-5" />
            <span className="sr-only">Close search</span>
          </DialogClose>
          <DialogTitle className="sr-only">Search</DialogTitle>
          <SearchBox
            autoFocus
            mode="inline"
            value={search.draft}
            onChange={search.setDraft}
            onSubmit={(q) => {
              search.submit(q)
              onOpenChange(false)
            }}
            className="flex-1"
          />
        </div>
        <div className="flex-1 overflow-y-auto px-3 pb-6">
          <p className="px-3 pt-2 text-xs text-muted-foreground">
            Combine tags with spaces – every tag has to match.
          </p>
          <button
            type="button"
            onClick={() => preferences.set((p) => ({ ...p, recentSearches: [] }))}
            className="mt-4 px-3 text-xs text-muted-foreground underline-offset-4 hover:underline"
          >
            Clear recent searches
          </button>
        </div>
      </SheetContent>
    </DialogRoot>
  )
}
